import type { IConfiguracionPostventa, IIncotermPostventa, IVariablesPostventa } from '../../../modelos/CotizadorPostventa/entidades/IConfiguracionPostventa';
import { generarIdTemporal } from '../../../globales/componentes/tabla/useEdicionFilas';

const incoterm = (Codigo: string, Descripcion: string): IIncotermPostventa => ({ Id: generarIdTemporal(), Codigo, Descripcion });

/** Valores del Excel "Liquidador MOD QR y otros SEB V7". Se usan hasta conectar el back. */
export const configuracionPostventaInicial: IConfiguracionPostventa = {
    FactorPrecio: 1.5,
    TarifaHoraHombre: 18500,
    Incoterms: [
        incoterm('EXW', 'En fábrica'),
        incoterm('FCA', 'Franco transportista'),
        incoterm('FOB', 'Franco a bordo'),
        incoterm('CIF', 'Costo, seguro y flete'),
        incoterm('DAP', 'Entregado en lugar'),
        incoterm('DDP', 'Entregado con derechos pagados')
    ]
};

export const variablesPostventaIniciales = ({ FactorPrecio, TarifaHoraHombre }: IVariablesPostventa): IVariablesPostventa => ({ FactorPrecio, TarifaHoraHombre });

/** Variables diligenciadas y mayores que cero. */
export const variablesPostventaCompletas = (variables: IVariablesPostventa) =>
    Object.values(variables).every(valor => valor !== null && valor !== undefined && String(valor) !== '' && Number(valor) > 0);
